/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscogsReleaseTracklistQuery
 */
export interface DiscogsReleaseTracklistQuery {
    /**
     * The release's id at Discogs.
     * @type {string}
     * @memberof DiscogsReleaseTracklistQuery
     */
    releaseId: string;
}

/**
 * Check if a given object implements the DiscogsReleaseTracklistQuery interface.
 */
export function instanceOfDiscogsReleaseTracklistQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;

    return isInstance;
}

export function DiscogsReleaseTracklistQueryFromJSON(json: any): DiscogsReleaseTracklistQuery {
    return DiscogsReleaseTracklistQueryFromJSONTyped(json, false);
}

export function DiscogsReleaseTracklistQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsReleaseTracklistQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
    };
}

export function DiscogsReleaseTracklistQueryToJSON(value?: DiscogsReleaseTracklistQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
    };
}

